module.exports = __webpack_public_path__ + "static/media/06-07.f5d169e8.png";